/**
 * bc-blog-carousel — Tabbed blog carousel with dots & arrows
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', initAllCarousels);

  function initAllCarousels() {
    document.querySelectorAll('[data-bc-blog-carousel]').forEach(initCarousel);
  }

  function initCarousel(root) {
    const tabs = root.querySelectorAll('[data-tab]');
    const panels = root.querySelectorAll('[data-panel]');

    if (!tabs.length || !panels.length) return;

    /* ── Tab switching ─────────────────────────────────────────── */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');

        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        panels.forEach(function (p) { p.classList.remove('is-active'); });
        var activePanel = root.querySelector('[data-panel="' + target + '"]');
        if (activePanel) {
          activePanel.classList.add('is-active');
          initPanel(activePanel);
        }
      });
    });

    /* Init first active panel */
    var firstActive = root.querySelector('.bc-blog-carousel__panel.is-active');
    if (firstActive) initPanel(firstActive);
  }

  function initPanel(panel) {
    var track = panel.querySelector('.bc-blog-carousel__track');
    var dotsWrap = panel.querySelector('.bc-blog-carousel__dots');
    var controlsWrap = panel.querySelector('.bc-blog-carousel__controls');
    var prevBtn = panel.querySelector('[data-arrow="prev"]');
    var nextBtn = panel.querySelector('[data-arrow="next"]');

    if (!track) return;

    var cards = track.querySelectorAll('.bc-blog-carousel__card');
    if (!cards.length) return;

    /* Calculate visible count */
    var visibleCount = getVisibleCount();
    var totalPages = Math.max(1, Math.ceil(cards.length / visibleCount));
    var currentPage = 0;

    /* Dots add nothing over the arrows at 2 pages; arrows add nothing at 1. */
    if (dotsWrap) dotsWrap.classList.toggle('is-hidden', totalPages <= 2);
    if (controlsWrap) controlsWrap.classList.toggle('is-hidden', totalPages <= 1);

    /* Build dots */
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < totalPages; i++) {
        var dot = document.createElement('button');
        dot.className = 'bc-blog-carousel__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.setAttribute('data-page', i);
        dot.addEventListener('click', function () {
          goToPage(parseInt(this.getAttribute('data-page')));
        });
        dotsWrap.appendChild(dot);
      }
    }

    /* Arrow handlers */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToPage(currentPage - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToPage(currentPage + 1);
      });
    }

    /* Scroll sync — update dots on manual scroll */
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncDotsFromScroll, 100);
    });

    function syncDotsFromScroll() {
      if (!cards.length) return;
      var cardWidth = cards[0].offsetWidth + getGap();
      var scrollPage = Math.round(track.scrollLeft / (cardWidth * visibleCount));
      scrollPage = Math.max(0, Math.min(scrollPage, totalPages - 1));
      if (scrollPage !== currentPage) {
        currentPage = scrollPage;
        updateDots();
      }
    }

    function goToPage(page) {
      if (page < 0) page = totalPages - 1;
      if (page >= totalPages) page = 0;
      currentPage = page;

      var cardWidth = cards[0].offsetWidth + getGap();
      track.scrollTo({
        left: currentPage * visibleCount * cardWidth,
        behavior: 'smooth'
      });

      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.bc-blog-carousel__dot');
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === currentPage);
      });
    }

    function getGap() {
      var style = getComputedStyle(track);
      return parseInt(style.gap) || 32;
    }

    function getVisibleCount() {
      var w = window.innerWidth;
      if (w <= 749) return 1;
      if (w <= 989) return 2;
      return 3;
    }
  }
})();
